import React, {FunctionComponent} from 'react'
import {Outlet} from "react-router-dom";

export const Layout: FunctionComponent = () => {
    return (
        <div className="text-neutral-400">
            {/*<Navbar>*/}
            {/*    <img src="/images/brand/mobility-concept.jpeg"*/}
            {/*         className={"w-32 md:w-[161px] h-4 md:h-5"} alt=""/>*/}
            {/*    <a href={'https://www.repareo.de'} className={'flex'} title={"repareo Werkstattvergleich"}>*/}
            {/*        <img*/}
            {/*            src="/images/brand/logo-light.svg"*/}
            {/*            className="w-24 h-auto"*/}
            {/*            alt=""*/}
            {/*        />*/}
            {/*    </a>*/}
            {/*</Navbar>*/}
            <Outlet/>
            {/*<Footer/>*/}
        </div>
    )
}
